import { TextLabel } from '@tonic-one/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import config from '../../../../../config';
import ReportContentCheckbox from '../../../ReportContentCheckbox';
import style from '../../index.module.less';
import { useOneTimeReportStore } from '../../store';

const ReportSections = () => {
  const { t } = useTranslation();

  //getter
  const sections = useOneTimeReportStore(
    (store) => store.reportContent.sections
  );

  //setter
  const setSections = useOneTimeReportStore((store) => store.setSections);

  //register
  const register = useOneTimeReportStore(
    (store) => store.registerResetCallback
  );
  const unregister = useOneTimeReportStore(
    (store) => store.unregisterResetCallback
  );

  useEffect(() => {
    const cb = () =>
      setSections({ ...config.ui.reportDefaultValue.reportContent });
    cb();
    register(cb);
    return () => unregister(cb);
  }, []);

  return (
    <>
      <TextLabel className={style.itemLabel}>
        {t('reportCommon.labels.sections')}:
      </TextLabel>
      <ReportContentCheckbox
        reportContent={sections}
        setReportContent={setSections}
      />
    </>
  );
};

export default ReportSections;
